import React, { useContext, useEffect } from 'react'
import { contextData } from '../../App'
import DanceClasses from '../../components/DanceClasses/DanceClasses';

function DanceClassesPage() {

  const {isScrolled,setIsScrolled} = useContext(contextData);

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsScrolled(true)
    return () => {
      setIsScrolled(false)
    }
  },[])

  return (
    <div className='pt-[114px]'>
        <DanceClasses/>
    </div>
  )
}

export default DanceClassesPage
